<template>
  <v-card class="card-container">
    <v-dialog v-model="saveDialog" persistent max-width="500">
      <v-card class="pa-4 text-center rounded-lg" :key="saveKey">
        <h2 class="main-toolbar-title">{{ $t('Salvar estudo') }}</h2>

        <v-form ref="saveForm" class="mt-4">
          <v-text-field
            hide-details="auto"
            placeholder="Nomeie o estudo salvo"
            outlined
            dense
            class="primary-input"
            v-model="studyName"
            :rules="[(v) => !!v || 'Digite um nome para o estudo salvo']"
          >
            <template #message="{ message }">
              {{ $t(message) }}
            </template>
          </v-text-field>
        </v-form>

        <div class="mt-4 d-flex justify-end">
          <v-btn
            class="primary-button"
            depressed
            @click=";(saveKey = !saveKey), (saveDialog = false)"
          >
            {{ $t('Cancelar') }}
          </v-btn>
          <v-btn
            class="secondary-button mr-0"
            depressed
            @click="saveToPriorityWithName"
          >
            {{ $t('Confirmar') }}
          </v-btn>
        </div>
      </v-card>
    </v-dialog>

    <div class="main-toolbar mb-2">
      <div class="icon-back">
        <v-icon id="icon" size="37" color="white"> mdi-find-replace </v-icon>
      </div>

      <span class="main-toolbar-title">{{
        $t('Relatórios - Estudo de Substituição')
      }}</span>
    </div>

    <div class="d-flex justify-end">
      <v-btn class="secondary-button ma-1" depressed @click="getExcel">
        Excel
      </v-btn>

      <v-btn
        class="primary-button ma-1"
        depressed
        @click="filters = !filters"
        >{{ filters ? $t('Fechar') : $t('Filtros') }}</v-btn
      >
    </div>

    <v-expand-transition>
      <div v-show="filters" class="mt-4">
        <v-row class="ma-0" dense>
          <v-col cols="12" sm="4">
            <v-autocomplete
              v-model="filter.institutionId"
              :items="institutions"
              item-text="name"
              item-value="id"
              class="primary-input"
              dense
              hide-details
              outlined
              append-icon="mdi-chevron-down"
              :label="$t('Instituição')"
              disabled
              @keyup.enter="filtrate"
            >
            </v-autocomplete>
          </v-col>

          <v-col cols="12" sm="4">
            <v-autocomplete
              v-model="filter.unidadeId"
              :items="unidades"
              append-icon="mdi-chevron-down"
              item-text="name"
              item-value="id"
              hide-details
              class="primary-input"
              dense
              outlined
              :label="$t('Unidade')"
              @keyup.enter="filtrate"
            >
            </v-autocomplete>
          </v-col>

          <v-col cols="12" sm="4">
            <v-autocomplete
              hide-details
              v-model="filter.departmentIds"
              :items="localDepartments"
              append-icon="mdi-chevron-down"
              multiple
              item-text="name"
              item-value="id"
              class="primary-input"
              dense
              outlined
              :label="$t('Setor')"
              @keyup.enter="filtrate"
            >
            </v-autocomplete>
          </v-col>

          <v-col cols="12" sm="4">
            <v-autocomplete
              v-model="filter.standardEquipmentIds"
              :items="standardEquipments"
              multiple
              item-text="name"
              item-value="id"
              hide-details
              class="primary-input"
              :search-input.sync="search"
              @blur="search = ''"
              dense
              append-icon="mdi-chevron-down"
              outlined
              :label="$t('Equipamento padrão')"
              @keyup.enter="filtrate"
            >
            </v-autocomplete>
          </v-col>

          <v-col cols="12" sm="4">
            <v-text-field
              v-model="filter.name"
              hide-details
              class="primary-input"
              dense
              outlined
              :label="$t('Equipamento')"
              @keyup.enter="filtrate"
            >
            </v-text-field>
          </v-col>

          <v-col cols="12" sm="4">
            <v-text-field
              v-model="filter.identification"
              hide-details
              class="primary-input"
              dense
              outlined
              :label="$t('Identificação')"
              @keyup.enter="filtrate"
            >
            </v-text-field>
          </v-col>

          <v-col cols="12" sm="4">
            <v-text-field
              hide-details
              v-model="filter.model"
              class="primary-input"
              dense
              outlined
              :label="$t('Modelo')"
              @keyup.enter="filtrate"
            >
            </v-text-field>
          </v-col>

          <v-col cols="12" sm="4">
            <v-autocomplete
              hide-details="auto"
              v-model="filter.manufacturer"
              :items="manufacturers"
              item-text="name"
              item-value="name"
              :label="$t('Fabricante')"
              dense
              outlined
              append-icon="mdi-chevron-down"
              class="primary-input"
              @keyup.enter="filtrate"
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" sm="4">
            <v-text-field
              v-model="filter.serialNumber"
              hide-details
              class="primary-input"
              dense
              outlined
              :label="$t('Número de série')"
              @keyup.enter="filtrate"
            >
            </v-text-field>
          </v-col>

          <v-col cols="12" sm="4">
            <v-text-field
              v-model="filter.propertyCode"
              hide-details
              class="primary-input"
              dense
              outlined
              :label="$t('Patrimônio')"
              @keyup.enter="filtrate"
            >
            </v-text-field>
          </v-col>

          <v-col cols="12" sm="4">
            <v-text-field
              v-model="filter.location"
              hide-details
              class="primary-input"
              dense
              outlined
              :label="$t('Localização')"
              @keyup.enter="filtrate"
            >
            </v-text-field>
          </v-col>

          <v-col cols="12" sm="4">
            <v-autocomplete
              v-model="filter.contract"
              :items="contracts"
              item-text="name"
              item-value="id"
              hide-details
              class="primary-input"
              dense
              append-icon="mdi-chevron-down"
              outlined
              :label="$t('Contrato')"
              @keyup.enter="filtrate"
            >
            </v-autocomplete>
          </v-col>

          <v-col cols="12" sm="3">
            <v-autocomplete
              v-model="filter.situation"
              hide-details
              :items="situations"
              item-text="text"
              item-value="value"
              class="primary-input"
              dense
              append-icon="mdi-chevron-down"
              outlined
              :label="$t('Situação')"
              @keyup.enter="filtrate"
            >
            </v-autocomplete>
          </v-col>

          <v-col cols="12" sm="3">
            <v-autocomplete
              v-model="filter.alienated"
              hide-details
              :items="alienatedOptions"
              item-text="text"
              item-value="value"
              class="primary-input"
              dense
              append-icon="mdi-chevron-down"
              outlined
              :label="$t('Alienado')"
              @keyup.enter="filtrate"
            >
            </v-autocomplete>
          </v-col>

          <v-col cols="12" sm="3">
            <v-text-field
              v-model="filter.criticalityMin"
              hide-details
              class="primary-input"
              dense
              type="number"
              outlined
              :label="$t('Criticidade (Mínima)')"
              @keyup.enter="filtrate"
            >
            </v-text-field>
          </v-col>

          <v-col cols="12" sm="3">
            <v-text-field
              v-model="filter.criticalityMax"
              hide-details
              class="primary-input"
              type="number"
              dense
              outlined
              :label="$t('Criticidade (Máxima)')"
              @keyup.enter="filtrate"
            >
            </v-text-field>
          </v-col>

          <v-col cols="12" sm="3">
            <v-menu
              ref="menuStartDate"
              v-model="menuStartDate"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-mask="['##/##/####']"
                  v-bind="attrs"
                  v-on="on"
                  autocomplete="off"
                  outlined
                  class="primary-input mr-2"
                  clearable
                  v-model="registerDateInitial"
                  @blur="calledStartDate = parseDate(registerDateInitial)"
                  hide-details
                  dense
                  :label="$t('Cadastro (inicial)')"
                  @keyup.enter="filtrate"
                >
                </v-text-field>
              </template>
              <v-date-picker
                v-model="calledStartDate"
                @change="save"
                locale="pt"
                no-title
              ></v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="12" sm="3">
            <v-menu
              ref="menuEndDate"
              v-model="menuEndDate"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-mask="['##/##/####']"
                  v-bind="attrs"
                  v-on="on"
                  autocomplete="off"
                  outlined
                  :disabled="!registerDateInitial"
                  class="primary-input mr-2"
                  clearable
                  v-model="registerDateEnd"
                  @blur="calledEndDate = parseDate(registerDateEnd)"
                  hide-details
                  dense
                  :label="$t('Cadastro (Final)')"
                  @keyup.enter="filtrate"
                >
                </v-text-field>
              </template>
              <v-date-picker
                v-model="calledEndDate"
                @change="save"
                locale="pt"
                no-title
              ></v-date-picker>
            </v-menu>
          </v-col>

          <!-- <v-col cols="12" sm="3">
            <v-text-field
              v-model="filter.lessPreventiveInitialDate"
              hide-details
              class="primary-input"
              type="date"
              dense
              outlined
              label="Equip. Crít. sem OS prev. (inical)"
              @keyup.enter="filtrate"
            >
            </v-text-field>
          </v-col>

          <v-col cols="12" sm="3">
            <v-text-field
              v-model="filter.lessPreventiveFinalDate"
              :disabled="!filter.lessPreventiveInitialDate"
              hide-details
              class="primary-input"
              type="date"
              dense
              outlined
              label="Equip. Crít. sem OS prev. (final)"
              @keyup.enter="filtrate"
            >
            </v-text-field>
          </v-col> -->

          <v-col cols="12" sm="3">
            <v-menu
              ref="menuStudyStartDate"
              v-model="menuStudyStartDate"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-mask="['##/##/####']"
                  v-bind="attrs"
                  v-on="on"
                  autocomplete="off"
                  outlined
                  class="primary-input mr-2"
                  clearable
                  v-model="studyDateInitial"
                  @blur="calledStudyStartDate = parseDate(studyDateInitial)"
                  hide-details
                  dense
                  :label="$t('Data de relatório (inicial)')"
                  @keyup.enter="filtrate"
                >
                </v-text-field>
              </template>
              <v-date-picker
                v-model="calledStudyStartDate"
                @change="saveStudy"
                locale="pt"
                no-title
              ></v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="12" sm="3">
            <v-menu
              ref="menuStudyEndDate"
              v-model="menuStudyEndDate"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-mask="['##/##/####']"
                  :disabled="!studyDateInitial"
                  v-bind="attrs"
                  v-on="on"
                  autocomplete="off"
                  outlined
                  class="primary-input mr-2"
                  clearable
                  v-model="studyDateEnd"
                  @blur="calledStudyEndDate = parseDate(studyDateEnd)"
                  hide-details
                  dense
                  :label="$t('Data de relatório (Final)')"
                  @keyup.enter="filtrate"
                >
                </v-text-field>
              </template>
              <v-date-picker
                v-model="calledStudyEndDate"
                @change="saveStudy"
                locale="pt"
                no-title
              ></v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="12" sm="3">
            <v-menu
              ref="menuWarrantyStartDate"
              v-model="menuWarrantyStartDate"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-mask="['##/##/####']"
                  v-bind="attrs"
                  v-on="on"
                  autocomplete="off"
                  outlined
                  class="primary-input mr-2"
                  clearable
                  v-model="warrantyDateInitial"
                  @blur="
                    calledWarrantyStartDate = parseDate(warrantyDateInitial)
                  "
                  hide-details
                  dense
                  :label="$t('Termino de garantia (inicial)')"
                  @keyup.enter="filtrate"
                >
                </v-text-field>
              </template>
              <v-date-picker
                v-model="calledWarrantyStartDate"
                @change="saveWarranty"
                locale="pt"
                no-title
              ></v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="12" sm="3">
            <v-menu
              ref="menuWarrantyEndDate"
              v-model="menuWarrantyEndDate"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-mask="['##/##/####']"
                  :disabled="!warrantyDateInitial"
                  v-bind="attrs"
                  v-on="on"
                  autocomplete="off"
                  outlined
                  class="primary-input mr-2"
                  clearable
                  v-model="warrantyDateEnd"
                  @blur="calledWarrantyEndDate = parseDate(warrantyDateEnd)"
                  hide-details
                  dense
                  :label="$t('Termino de garantia (Final)')"
                  @keyup.enter="filtrate"
                >
                </v-text-field>
              </template>
              <v-date-picker
                v-model="calledWarrantyEndDate"
                @change="saveWarranty"
                locale="pt"
                no-title
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="3">
            <v-menu
              ref="menuAlienetedStartDate"
              v-model="menuAlienetedStartDate"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-mask="['##/##/####']"
                  v-bind="attrs"
                  v-on="on"
                  autocomplete="off"
                  outlined
                  class="primary-input mr-2"
                  clearable
                  v-model="alienetedDateInitial"
                  @blur="
                    calledAlienetedStartDate = parseDate(alienetedDateInitial)
                  "
                  hide-details
                  dense
                  :label="$t('Data alienado (inicial)')"
                  @keyup.enter="filtrate"
                >
                </v-text-field>
              </template>
              <v-date-picker
                v-model="calledAlienetedStartDate"
                @change="saveAlieneted"
                locale="pt"
                no-title
              ></v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="12" sm="3">
            <v-menu
              ref="menuAlienetedEndDate"
              v-model="menuAlienetedEndDate"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-mask="['##/##/####']"
                  :disabled="!alienetedDateInitial"
                  v-bind="attrs"
                  v-on="on"
                  autocomplete="off"
                  outlined
                  class="primary-input mr-2"
                  clearable
                  v-model="alienetedDateEnd"
                  @blur="calledAlienetedEndDate = parseDate(alienetedDateEnd)"
                  hide-details
                  dense
                  :label="$t('Data alienado (Final)')"
                  @keyup.enter="filtrate"
                >
                </v-text-field>
              </template>
              <v-date-picker
                v-model="calledAlienetedEndDate"
                @change="saveAlieneted"
                locale="pt"
                no-title
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>

        <div class="pa-4 d-flex justify-end">
          <v-btn class="mx-2 secondary-button" @click="filtrate" depressed>
            <span>{{ $t('Filtrar') }}</span>
            <v-icon class="pl-2">mdi-magnify</v-icon>
          </v-btn>

          <v-btn depressed class="clear-button mr-0" @click="reset">
            <span>{{ $t('Limpar') }}</span>
            <v-icon class="pl-2">mdi-cached</v-icon>
          </v-btn>
        </div>
      </div>
    </v-expand-transition>

    <v-tabs
      :height="40"
      :mobile-break-point="300"
      v-model="tab"
      class="ma-auto mt-2 mb-2"
    >
      <v-tabs-slider color="#BBCF20"></v-tabs-slider>
      <v-tab
        active-class="activated-tab"
        class="rounded-lg rounded-b-0"
        href="#tabInput"
        v-show="visible"
      >
        {{ $t('Imputáveis e coletáveis') }}
      </v-tab>
      <v-tab
        active-class="activated-tab"
        class="rounded-lg rounded-b-0"
        href="#tabOrder"
        v-show="visible"
      >
        {{ $t('Ordem de priorização') }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab" touchless>
      <v-tab-item value="tabInput">
        <span
          >* O usuário precisa salvar página por página para que a "Ordem de
          priorização" apresente todos os equipamentos.</span
        >
        <div class="d-flex justify-end">
          <v-btn class="secondary-button" depressed @click="saveToPriority">
            {{ $t('Salvar para ordem de priorização') }}
          </v-btn>
        </div>

        <v-simple-table class="replace-table" dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="py-4 text-center"></th>
                <th class="py-4 text-center" colspan="7">
                  {{ $t('Dados gerais dos equipamentos') }}
                </th>
                <th class="py-4 text-center" colspan="6">
                  {{ $t('Dados coletáveis') }}
                </th>
                <th class="py-4 text-center" colspan="3">
                  {{ $t('Dados imputáveis') }}
                </th>
                <th class="py-4 text-center" rowspan="2">
                  {{ $t('Valor de mercado') }}
                </th>
                <th class="py-4 text-center" colspan="3">
                  {{ $t('Fatores') }}
                </th>
              </tr>
              <tr>
                <th class="py-4 text-center"></th>
                <th class="py-4 text-center">{{ $t('Equipamento') }}</th>
                <th class="py-4 text-center">
                  {{ $t('Identificação') }}
                </th>
                <th class="py-4 text-center">{{ $t('Fabricante') }}</th>
                <th class="py-4 text-center">{{ $t('Modelo') }}</th>
                <th class="py-4 text-center">{{ $t('Número de série') }}</th>
                <th class="py-4 text-center">{{ $t('Patrimônio') }}</th>
                <th class="py-4 text-center">{{ $t('Setor') }}</th>

                <th
                  class="py-4 text-center"
                  style="border-left: 1px solid #0004"
                >
                  {{ $t('Data de aquisição') }}
                </th>
                <th class="py-4 text-center" colspan="2">
                  {{ $t('Criticidade') }}
                </th>
                <th class="py-4 text-center">
                  {{ $t('Expectativa de vida') }}
                </th>
                <th class="py-4 text-center">
                  {{ $t('Custo com manutenção') }}
                </th>
                <th class="py-4 text-center">{{ $t('Número de falhas') }}</th>
                <th
                  class="py-4 text-center"
                  style="border-left: 1px solid #0004"
                >
                  {{ $t('Estado de conservação') }}
                </th>
                <th class="py-4 text-center">{{ $t('Fator fim de vida') }}</th>
                <th
                  class="py-4 text-center"
                  style="border-right: 1px solid #0004"
                >
                  {{ $t('Fator tecnologia') }}
                </th>
                <th class="py-4 text-center">{{ $t('Idade') }}</th>
                <th class="py-4 text-center">
                  {{ $t('Custo de manutenção') }}
                </th>
                <th class="py-4 text-center">{{ $t('Número de falhas') }}</th>
              </tr>
            </thead>
            <tbody class="items">
              <tr v-for="item in itemsChargeable" :key="item.id">
                <td class="py-4 text-center"></td>
                <td class="py-4 text-center">
                  {{ item.equipment }}
                </td>
                <td class="py-4 text-center">
                  {{ item.identification }}
                </td>
                <td class="py-4 text-center">
                  {{ item.manufacturer }}
                </td>
                <td class="py-4 text-center">
                  {{ item.model }}
                </td>
                <td class="py-4 text-center">
                  {{ item.serialNumber }}
                </td>
                <td class="py-4 text-center">
                  {{ item.patrimony }}
                </td>
                <td class="py-4 text-center">
                  {{ item.sector }}
                </td>
                <td class="py-4 text-center">
                  {{ formatDate(item.acquisitionDate) }}
                </td>
                <td
                  class="py-4 text-center"
                  style="border-left: 1px solid #0004"
                >
                  {{ item.criticalityNumber }}
                </td>
                <td
                  class="py-4 text-center"
                  style="border-right: 1px solid #0004"
                >
                  {{ item.criticality }}
                </td>
                <td class="py-4 text-center">{{ item.lifeExpectancy }}</td>

                <td class="py-4 text-center">
                  {{ item.maintenanceCost.toInstLocale() }}
                </td>
                <td class="py-4 text-center">{{ item.failsNumber }}</td>
                <td class="py-4 text-center">
                  <v-select
                    dense
                    hide-details=""
                    filled
                    append-icon="mdi-chevron-down"
                    single-line
                    :items="conservationStates"
                    v-model="item.conservationState"
                    item-value="value"
                    item-text="text"
                  >
                    <template v-slot:selection="{ item }">
                      <span class="text-caption">
                        {{ $t(item.text) }}
                      </span>
                    </template>

                    <template v-slot:item="{ item }">
                      <span class="text-caption">
                        {{ $t(item.text) }}
                      </span>
                    </template>
                  </v-select>
                </td>
                <td class="py-4 text-center">
                  <v-select
                    dense
                    hide-details=""
                    filled
                    append-icon="mdi-chevron-down"
                    single-line
                    :items="endLifeFactors"
                    v-model="item.endLifeFactor"
                    item-value="value"
                    item-text="text"
                  >
                    <template v-slot:selection="{ item }">
                      <span class="text-caption">
                        {{ $t(item.text) }}
                      </span>
                    </template>

                    <template v-slot:item="{ item }">
                      <span class="text-caption">
                        {{ $t(item.text) }}
                      </span>
                    </template>
                  </v-select>
                </td>
                <td class="py-4 text-center">
                  <v-select
                    dense
                    hide-details=""
                    filled
                    append-icon="mdi-chevron-down"
                    single-line
                    :items="technologyFactors"
                    v-model="item.technologyFactor"
                    item-value="value"
                    item-text="text"
                  >
                    <template v-slot:selection="{ item }">
                      <span class="text-caption">
                        {{ $t(item.text) }}
                      </span>
                    </template>

                    <template v-slot:item="{ item }">
                      <span class="text-caption">
                        {{ $t(item.text) }}
                      </span>
                    </template>
                  </v-select>
                </td>
                <td class="py-4 text-center">
                  <v-currency-field
                    dense
                    hide-details=""
                    filled
                    single-line
                    v-model="item.marketValue"
                  >
                  </v-currency-field>
                </td>
                <td class="py-4 text-center">
                  {{ item.ageFactor.toFixed(2) }}
                </td>
                <td class="py-4 text-center">
                  {{ item.maintenanceCostFactor.toFixed(2) }}
                </td>
                <td class="py-4 text-center">
                  {{ item.failsNumberFactor.toFixed(2) }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>

        <div class="pagination mx-2">
          <div class="item-pagination block-one">
            <div class="registros" v-if="itemsChargeable.length">
              <span>
                1 - {{ itemsChargeable.length * filter.page }} de
                {{ chargeableTotalItems }}
              </span>
              <br />
              <!-- <span>
              Selecionados:
              {{ items.length }}
            </span> -->
            </div>
          </div>

          <div class="item-pagination block-two">
            <v-pagination
              @change="listChargeable"
              class="pagination-item"
              v-model="filter.page"
              :length="filter.totalPages"
              :total-visible="5"
            ></v-pagination>
          </div>
        </div>
      </v-tab-item>

      <v-tab-item value="tabOrder">
        <span
          >* O usuário precisa salvar página por página para que a "Ordem de
          priorização" apresente todos os equipamentos.</span
        >
        <div v-if="priorities && priorities.length > 0">
          <v-simple-table class="main-table" dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-center"></th>
                  <th class="text-center">{{ $t('Estudo') }}</th>
                  <th class="text-center">{{ $t('Criado em') }}</th>
                  <th class="text-center"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in priorities" :key="item.equipmentId">
                  <td class="text-center"></td>
                  <td class="text-center">
                    {{ item.name ? item.name : 'Sem registro' }}
                  </td>
                  <td class="text-center">
                    {{ formatDate(item.createdAt) }}
                  </td>
                  <td class="text-center">
                    <v-btn
                      tile
                      text
                      @click="
                        ;(filter.priorityOrderId = item.id), listPriority()
                      "
                    >
                      {{ priorityId == item.id ? 'Atual' : 'Inspecionar' }}
                    </v-btn>
                    <v-btn tile text @click="removeSavedPriority(item.id)" icon>
                      <v-icon>mdi-trash-can-outline</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>

          <div class="pagination mx-2">
            <div class="item-pagination block-two">
              <v-pagination
                @change="listPriorities"
                class="pagination-item"
                v-model="priorityPage"
                :length="priorityTotalPages"
                :total-visible="5"
              ></v-pagination>
            </div>
          </div>
        </div>

        <div class="d-flex justify-space-between">
          <v-row>
            <v-col cols="12" sm="6">
              <div class="d-flex align-center mt-4">
                <span class="mr-2"
                  >{{ $t('Linha de corte de investimento') }}:</span
                >
                <div style="border-top: 3px solid red; width: 25px"></div>
              </div>
            </v-col>
            <v-col cols="12" sm="6">
              <v-card
                class="card-pad d-flex align-center mt-6 white--text"
                style="background: #b9ce1e !important"
                max-width="400"
              >
                <strong>{{ $t('Orçamento') }}:</strong>

                <v-spacer></v-spacer>

                <v-currency-field
                  class="mx-2"
                  v-model="filter.budget"
                  dark
                  validate-on-blur
                  hide-details="auto"
                  outlined
                >
                </v-currency-field>

                <v-spacer></v-spacer>

                <v-btn
                  small
                  class="primary-button"
                  depressed
                  @click="listPriority"
                >
                  {{ $t('Enviar') }}
                </v-btn>
              </v-card>
            </v-col>
          </v-row>
        </div>

        <div class="d-flex justify-end mt-6">
          <v-btn
            class="terciary-button ma-1"
            depressed
            @click="removeToPriority"
          >
            {{ $t('Limpar estudo') }}
          </v-btn>
          <v-btn
            @click=";(saveKey = !saveKey), (saveDialog = true)"
            depressed
            class="primary-button ma-1"
          >
            {{ $t('Salvar') }}
          </v-btn>
        </div>

        <v-simple-table class="replace-table table2" dense>
          <template v-slot:default>
            <thead>
              <tr></tr>
              <tr>
                <th class="py-4 text-center"></th>
                <th class="py-4 text-center">{{ $t('Equipamento') }}</th>
                <th class="py-4 text-center">
                  {{ $t('Identificação') }}
                </th>
                <th class="py-4 text-center">{{ $t('Fabricante') }}</th>
                <th class="py-4 text-center">{{ $t('Modelo') }}</th>
                <th class="py-4 text-center">{{ $t('Número de série') }}</th>
                <th class="py-4 text-center">{{ $t('Patrimônio') }}</th>
                <th class="py-4 text-center">{{ $t('Setor') }}</th>
                <th class="py-4 text-center">{{ $t('Data de aquisição') }}</th>
                <th class="py-4 px-2 secondary text-center">
                  {{ $t("Número de prioridade 'K'") }}
                </th>
                <th class="py-4 text-center">
                  {{ $t('Custo de substituição') }}
                </th>
                <th class="py-4 text-center">
                  {{ $t('Custo acumulativo de substituição') }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in underBudgetItems" :key="item.equipmentId">
                <td class="py-4 text-center"></td>
                <td class="py-4 text-center">
                  {{ item.equipment }}
                </td>
                <td class="py-4 text-center">
                  {{ item.identification }}
                </td>
                <td class="py-4 text-center">
                  {{ item.manufacturer }}
                </td>
                <td class="py-4 text-center">
                  {{ item.model }}
                </td>
                <td class="py-4 text-center">
                  {{ item.serialNumber }}
                </td>
                <td class="py-4 text-center">
                  {{ item.patrimony }}
                </td>
                <td class="py-4 text-center">
                  {{ item.sector }}
                </td>
                <td class="py-4 text-center">
                  {{ formatDate(item.acquisitionDate) }}
                </td>
                <td
                  class="py-4 secondary text-center"
                  style="color: white !important"
                >
                  <strong> {{ item.k.toFixed(2) }} </strong>
                </td>
                <td class="py-4 text-center">
                  {{ item.substitutionCost.toInstLocale() }}
                </td>
                <td class="py-4 text-center">
                  {{ item.cumulativeCost.toInstLocale() }}
                </td>
              </tr>
              <tr
                v-for="(item, index) in overBudgetItems"
                :key="item.equipmentId"
              >
                <td
                  class="py-4 text-center"
                  :class="index == 0 ? 'cut-line' : ''"
                ></td>
                <td
                  class="py-4 text-center"
                  :class="index == 0 ? 'cut-line' : ''"
                >
                  {{ item.equipment }}
                </td>
                <td
                  class="py-4 text-center"
                  :class="index == 0 ? 'cut-line' : ''"
                >
                  {{ item.identification }}
                </td>
                <td
                  class="py-4 text-center"
                  :class="index == 0 ? 'cut-line' : ''"
                >
                  {{ item.manufacturer }}
                </td>
                <td
                  class="py-4 text-center"
                  :class="index == 0 ? 'cut-line' : ''"
                >
                  {{ item.model }}
                </td>
                <td
                  class="py-4 text-center"
                  :class="index == 0 ? 'cut-line' : ''"
                >
                  {{ item.serialNumber }}
                </td>
                <td
                  class="py-4 text-center"
                  :class="index == 0 ? 'cut-line' : ''"
                >
                  {{ item.patrimony }}
                </td>
                <td
                  class="py-4 text-center"
                  :class="index == 0 ? 'cut-line' : ''"
                >
                  {{ item.sector }}
                </td>
                <td
                  class="py-4 text-center"
                  :class="index == 0 ? 'cut-line' : ''"
                >
                  {{ formatDate(item.acquisitionDate) }}
                </td>
                <td
                  class="py-4 secondary text-center"
                  style="color: white !important"
                  :class="index == 0 ? 'cut-line' : ''"
                >
                  <strong>
                    {{ item.k ? item.k.toFixed(2) : $t('Sem registros') }}
                  </strong>
                </td>
                <td
                  class="py-4 text-center"
                  :class="index == 0 ? 'cut-line' : ''"
                >
                  {{ item.substitutionCost.toInstLocale() }}
                </td>
                <td
                  class="py-4 text-center"
                  :class="index == 0 ? 'cut-line' : ''"
                >
                  {{ item.cumulativeCost.toInstLocale() }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>

        <div class="pagination mx-2">
          <div class="item-pagination block-one">
            <div class="registros" v-if="items.length">
              <span> 1 - {{ items.length }} </span>
              <br />
              <!-- <span>
              Selecionados:
              {{ items.length }}
            </span> -->
            </div>
          </div>
        </div>

        <v-lazy
          :options="{
            threshold: 0.5,
          }"
          transition="fade-transition"
        >
          <div v-if="showIntersect">
            <v-card
              height="2"
              elevation="0"
              v-intersect="infiniteScrolling"
            ></v-card>
          </div>
        </v-lazy>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import ApiService from '../../../services/ApiService'
import moment from 'moment'
import GeneralService from '../../../services/GeneralService'

export default {
  name: 'ReplacementStudy',

  async created() {
    this.userLogged = JSON.parse(localStorage.getItem('user'))
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.institutionId = JSON.parse(localStorage.getItem('institution')).id
    this.filter.institutionId = this.institutionId

    if (this.institution.userType > 1) {
      this.getUserUnidades()
    } else {
      this.getUnidades()
    }

    await Promise.all([
      this.getInstitutions(),
      this.getDepartments(),
      this.getContracts(),
      this.getStandardEquipment(),
      this.getManufacturers(),
    ])

    await this.listChargeable()
    await this.listPriorities()
    await this.listPriority()
  },

  mounted() {
    setTimeout(() => {
      const slider = document.querySelector(
        '.replace-table .v-data-table__wrapper'
      )
      let isDown = false
      let startX
      let scrollLeft

      slider.addEventListener('mousedown', (e) => {
        isDown = true
        slider.classList.add('active')
        startX = e.pageX - slider.offsetLeft
        scrollLeft = slider.scrollLeft
      })
      slider.addEventListener('mouseleave', () => {
        isDown = false
        slider.classList.remove('active')
      })
      slider.addEventListener('mouseup', () => {
        isDown = false
        slider.classList.remove('active')
      })
      slider.addEventListener('mousemove', (e) => {
        if (!isDown) return
        e.preventDefault()
        const x = e.pageX - slider.offsetLeft
        const walk = (x - startX) * 3 //scroll-fast
        slider.scrollLeft = scrollLeft - walk
      })
    }, 2000)
  },

  computed: {
    underBudgetItems() {
      return this.items.filter((x) => x.underBudget)
    },
    overBudgetItems() {
      return this.items.filter((x) => !x.underBudget)
    },
  },

  data() {
    return {
      manufacturers: [],
      endDate: null,
      calledEndDate: null,
      calledStartDate: null,
      menuStartDate: false,
      menuEndDate: false,
      minDate: null,
      registerDateInitial: null,
      registerDateEnd: null,

      menuStudyStartDate: false,
      menuStudyEndDate: false,
      calledStudyEndDate: null,
      calledStudyStartDate: null,
      studyDateInitial: null,
      studyDateEnd: null,

      menuAlienetedStartDate: false,
      menuAlienetedEndDate: false,
      calledAlienetedEndDate: null,
      calledAlienetedStartDate: null,
      alienetedDateInitial: null,
      alienetedDateEnd: null,

      menuWarrantyStartDate: false,
      menuWarrantyEndDate: false,
      calledWarrantyEndDate: null,
      calledWarrantyStartDate: null,
      warrantyDateInitial: null,
      warrantyDateEnd: null,

      search: '',
      priorityTotalPages: null,
      showIntersect: false,
      tab: null,
      visible: true,
      studyName: '',
      saveKey: false,
      saveDialog: false,
      conservationStates: [
        { text: 'Bom', value: 0 },
        { text: 'Ruim', value: 1 },
        { text: 'Péssimo', value: 2 },
      ],
      endLifeFactors: [
        { text: 'Atual', value: null },
        { text: 'End of Life', value: 0 },
        { text: 'End of Service', value: 1 },
      ],
      technologyFactors: [
        { text: '-', value: null },
        { text: 'Atual', value: 0 },
        { text: 'Defasagem Mínima', value: 1 },
        { text: 'Defasado', value: 2 },
      ],
      userLogged: {},
      filters: false,
      filter: {
        alienatedEndDate: null,
        alienatedStartDate: null,
        costInitialDate: null,
        costFinalDate: null,
        totalPages: 0,
        totalItems: 0,
        page: 1,
        budget: 0,
        page: 1,
        pageSize: 10,
        name: null,
        model: null,
        serialNumber: null,
        criticalityMin: 0,
        criticalityMax: 0,
        departmentId: 0,
        contractId: 0,
        registerDateInitial: null,
        registerDateFinal: null,
        institutionId: null,
        unidadeId: 0,
        warrantyStartDate: null,
        warrantyEndDate: null,
        lessPreventiveInitialDate: null,
        lessPreventiveFinalDate: null,
        alienated: false,
        situation: -1,
        identification: null,
        manufacturer: null,
        propertyCode: null,
        standardEquipmentId: null,
        ordination: null,
      },
      alienatedOptions: [
        { text: 'Não', value: false },
        { text: 'Sim', value: true },
      ],

      institutionId: '',
      items: [],
      itemsChargeable: [],
      loading: false,
      institutions: [],
      unidades: [],
      departments: [],
      contracts: [],
      priorityId: '',
      situations: [
        { text: 'Aluguel', value: 0 },
        { text: 'Comodato', value: 1 },
        { text: 'De médico/Equipe', value: 2 },
        { text: 'Empréstimo', value: 3 },
        { text: 'Próprio', value: 4 },
        { text: 'Terceiros', value: 5 },
      ],
      priorities: [],
      priorityPage: 1,
      chargeableTotalItems: 0,
      priorityTotalItems: 0,
      standardEquipments: [],
      equipmentsToChange: [],
      apiService: new ApiService(),
      generalService: new GeneralService(),
      localDepartments: [],
    }
  },

  methods: {
    getManufacturers() {
      this.manufacturerLoading = true
      this.apiService
        .get(`manufacturer/list/${this.institutionId}`)
        .then((response) => {
          this.manufacturers = response.content
          this.manufacturerLoading = false
        })
        .catch(() => {
          this.manufacturerLoading = false
        })
    },

    parseDate(date) {
      if (!date) return null

      const [day, month, year] = date.split('/')

      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    formatInputDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    save(date) {
      this.registerDateInitial = this.formatInputDate(this.calledStartDate)
      this.$refs.menuStartDate.save(date)
      this.minDate = new Date(this.calledStartDate).toISOString().substr(0, 10)
      this.registerDateEnd = this.formatInputDate(this.calledEndDate)
      this.$refs.menuEndDate.save(date)
    },

    saveStudy(date) {
      this.studyDateInitial = this.formatInputDate(this.calledStudyStartDate)
      this.$refs.menuStudyStartDate.save(date)
      this.minDate = new Date(this.calledStudyStartDate)
        .toISOString()
        .substr(0, 10)
      this.studyDateEnd = this.formatInputDate(this.calledStudyEndDate)
      this.$refs.menuStudyEndDate.save(date)
    },

    saveWarranty(date) {
      this.warrantyDateInitial = this.formatInputDate(
        this.calledWarrantyStartDate
      )
      this.$refs.menuWarrantyStartDate.save(date)
      this.minDate = new Date(this.calledWarrantyStartDate)
        .toISOString()
        .substr(0, 10)
      this.warrantyDateEnd = this.formatInputDate(this.calledWarrantyEndDate)
      this.$refs.menuWarrantyEndDate.save(date)
    },

    saveAlieneted(date) {
      this.alienetedDateInitial = this.formatInputDate(
        this.calledAlienetedStartDate
      )
      this.$refs.menuAlienetedStartDate.save(date)
      this.minDate = new Date(this.calledAlienetedStartDate)
        .toISOString()
        .substr(0, 10)
      this.alienetedDateEnd = this.formatInputDate(this.calledAlienetedEndDate)
      this.$refs.menuAlienetedEndDate.save(date)
    },

    getExcel() {
      this.loading = true

      this.apiService
        .post('equipment/priorityOrder/excel', this.filter)
        .then((response) => {
          response = `data:application/octet-stream;base64,${response.content}`
          const link = document.createElement('a')
          link.href = response
          link.setAttribute('download', 'OrdemPrioridade.xlsx')
          document.body.appendChild(link)
          link.click()

          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },

    async saveToPriority() {
      await this.apiService
        .post('equipment/priority/save', {
          name: this.studyName,
          institutionId: this.institutionId,
          edits: this.itemsChargeable,
          priorityId: this.priorityId,
        })
        .then(async () => {
          this.reset()
          await this.listPriorities()
          await this.listPriority()
          this.saveKey = !this.saveKey
          this.saveDialog = false
          this.studyName = ''
          this.tab = 1
        })
    },

    async saveToPriorityWithName() {
      if (this.$refs.saveForm.validate()) {
        await this.apiService
          .post('equipment/priority/save', {
            showInTable: true,
            name: this.studyName,
            institutionId: this.institutionId,
            edits: this.items,
          })
          .then(async () => {
            this.reset()
            await this.listPriorities()
            await this.listPriority()
            this.saveKey = !this.saveKey
            this.saveDialog = false
            this.studyName = ''
            this.tab = 1
          })
      }
    },

    async removeToPriority() {
      this.priorityId = null
      this.items = []
    },

    async removeSavedPriority(itemId) {
      await this.apiService
        .delete(`equipment/priority/${this.institutionId}/${itemId}`)
        .then(() => {
          this.listPriorities()
          this.listPriority()
        })
    },

    async getInstitutions() {
      await this.apiService
        .get('institution/list', true, false)
        .then((response) => {
          this.institutions = response.content
        })
    },

    async getUnidades() {
      await this.apiService
        .get(`unidade/list/${this.institutionId}`, true, false)
        .then((response) => {
          this.unidades = response.content
        })
    },

    async getUserUnidades() {
      await this.apiService
        .get(
          `unidade/listByUserAndInstitution/${this.institutionId}`,
          true,
          false
        )
        .then((response) => {
          this.unidades = response.content
        })
    },

    async getDepartments() {
      await this.apiService
        .get(`department/listActive/${this.institutionId}`, true, false)
        .then((response) => {
          this.departments = response.content
          this.localDepartments = this.departments.filter((x) =>
            this.unidades.map((x) => x.id).includes(x.unidadeId)
          )
        })
    },

    async getContracts() {
      await this.apiService
        .get(`contract/list/${this.institutionId}`, true, false)
        .then((response) => {
          this.contracts = response.content
        })
    },

    async getStandardEquipment() {
      this.standardEquipments =
        await this.generalService.getStandardEquipmentsByInstitution(
          this.institutionId
        )
    },

    async filtrate() {
      this.filter.page = 1
      this.filter.registerDateInitial = this.calledStartDate

      this.filter.registerDateFinal = this.calledEndDate
      this.filter.costInitialDate = this.calledStudyStartDate
      this.filter.costFinalDate = this.calledStudyEndDate

      this.filter.warrantyStartDate = this.calledWarrantyStartDate
      this.filter.warrantyEndDate = this.calledWarrantyEndDate

      this.filter.alienatedEndDate = this.calledAlienetedEndDate
      this.filter.alienatedStartDate = this.calledAlienetedStartDate

      if (this.tab == 'tabInput') {
        await this.listChargeable()
      } else {
        this.listPriorities()
        await this.listPriority()
      }
    },

    reset() {
      this.filter = {
        budget: 0,
        page: 1,
        pageSize: 10,
        name: null,
        model: null,
        serialNumber: null,
        criticalityMin: 0,
        criticalityMax: 0,
        departmentId: 0,
        contractId: 0,
        registerDateInitial: null,
        registerDateFinal: null,
        institutionId: this.institutionId,
        unidadeId: 0,
        warrantyStartDate: null,
        warrantyEndDate: null,
        lessPreventiveInitialDate: null,
        lessPreventiveFinalDate: null,
        alienated: false,
        situation: -1,
        identification: null,
        manufacturer: null,
        propertyCode: null,
        standardEquipmentId: null,
        ordination: null,
      }
    },

    formatDate(date) {
      return date
        ? moment(date).locale(this.$i18n.locale).format('DD/MM/YYYY hh:mm:ss')
        : date
    },

    formatCurrency(value) {
      return value ? value.toInstLocale() : 0
    },

    async listChargeable() {
      this.loading = true

      await this.apiService
        .post('equipment/chargeableAndCollectable', this.filter)
        .then((response) => {
          this.itemsChargeable = response.content.results
          const pager = response.content.pager
          this.chargeableTotalItems = pager.totalItems
          this.filter.totalPages = pager.totalPages
          this.filter.endPage = pager.endPage

          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },

    async listPriority() {
      this.loading = true

      await this.apiService
        .post('equipment/priorityOrder', this.filter)
        .then((response) => {
          this.items = response.content.results
          this.priorityId = response.content.priorityId
          this.items.sort(
            (a, b) => Number(b.underBudget) - Number(a.underBudget)
          )
          this.priorityTotalItems = response.content.pager.totalItems
          this.loading = false
          setTimeout(() => {
            this.showIntersect = true
          }, 5000)
        })
        .catch(() => {
          this.loading = false
        })
    },

    async listPriorities() {
      this.loading = true

      await this.apiService
        .get(
          `equipment/priorityOrder/list/${this.filter.institutionId}/${this.priorityPage}`
        )
        .then((response) => {
          this.priorities = response.content.orders
          this.priorityTotalPages = response.content.pager.totalPages
        })
        .catch(() => {
          this.loading = false
        })
    },

    infiniteScrolling() {
      setTimeout(() => {
        const newPage = this.filter.page + 1
        if (
          newPage <= this.filter.endPage &&
          this.items.length < this.priorityTotalItems
        ) {
          this.filter.page++
          this.apiService
            .post('equipment/priorityOrder', this.filter)
            .then((response) => {
              this.items.push(...response.content.results)
              this.items.sort(
                (a, b) => Number(b.underBudget) - Number(a.underBudget)
              )

              this.priorityTotalItems = response.content.pager.totalItems
              this.loading = false
            })
            .catch((err) => {
              this.loading = false
            })
        }
      }, 500)
    },
  },

  watch: {
    'filter.unidadeId': {
      deep: true,
      handler() {
        if (this.filter.unidadeId) {
          this.localDepartments = this.departments.filter(
            (x) => x.unidadeId == this.filter.unidadeId
          )
        } else {
          this.localDepartments = this.departments.filter((x) =>
            this.unidades.map((x) => x.id).includes(x.unidadeId)
          )
        }
      },
    },

    priorityPage() {
      this.listPriorities()
    },

    'filter.page': {
      deep: true,
      handler() {
        this.listChargeable()
      },
    },
    async tab(nv) {
      this.filter.page = 1
      if (this.tab == 1) {
        await this.listPriorities()
        await this.listPriority()

        setTimeout(() => {
          const slider = document.querySelector(
            '.table2 .v-data-table__wrapper'
          )
          let isDown = false
          let startX
          let scrollLeft

          slider.addEventListener('mousedown', (e) => {
            isDown = true
            slider.classList.add('active')
            startX = e.pageX - slider.offsetLeft
            scrollLeft = slider.scrollLeft
          })
          slider.addEventListener('mouseleave', () => {
            isDown = false
            slider.classList.remove('active')
          })
          slider.addEventListener('mouseup', () => {
            isDown = false
            slider.classList.remove('active')
          })
          slider.addEventListener('mousemove', (e) => {
            if (!isDown) return
            e.preventDefault()
            const x = e.pageX - slider.offsetLeft
            const walk = (x - startX) * 3 //scroll-fast
            slider.scrollLeft = scrollLeft - walk
          })
        }, 1000)
      }
    },
  },
}
</script>

<style scoped>
.cut-line {
  border-top: 2px solid red !important;
}

.replace-table {
  margin-top: 25px;
}

.replace-table thead tr {
  border-radius: 4px !important;
}

.replace-table thead tr:first-child th:not(:first-child) {
  border-right: 1px solid #0004;
}

.replace-table thead tr:first-child th {
  background: #2a8ea4;
  font-weight: 600 !important;
  font-size: 11px !important;
  line-height: 14px !important;
  color: #ffffff !important;
  min-width: 145px !important;
  padding-left: 5px !important;
}

.replace-table thead tr th {
  background: #4c6d97;
  font-weight: 600 !important;
  font-size: 11px !important;
  line-height: 14px !important;
  color: #ffffff !important;
  min-width: 145px !important;
  padding-left: 5px !important;
}

.replace-table thead tr th:first-child {
  min-width: 10px !important;
  max-width: 10px !important;
  border-radius: 0px 0 0 4px !important;
  padding-left: 15px !important;
}

.replace-table thead tr th:last-child {
  padding-right: 16px !important;
  border-radius: 0 0px 4px 0 !important;
  min-width: 220px !important;
}

.replace-table thead tr:first-child th:first-child {
  border-radius: 4px 0 0 0px !important;
  padding-left: 15px !important;
}

.replace-table thead tr:first-child th:last-child {
  padding-right: 16px !important;
  border-radius: 0 4px 0px 0 !important;
  min-width: 220px !important;
}

.replace-table.replace-table thead tr th:last-child {
  min-width: 105px !important;
}

.replace-table tbody tr td:nth-child(2) {
  color: black !important;
  font-weight: 600 !important;
}

.replace-table tbody tr td:first-child {
  padding-left: 15px !important;
}

.replace-table tbody tr td {
  font-weight: 300 !important;
  font-size: 12px !important;
  line-height: 15px !important;
  letter-spacing: 0.15px !important;
  color: #808080 !important;
  border-bottom: 1px solid #ededed !important;
  padding-left: 5px !important;
}

.replace-table tbody tr td a {
  color: black;
  font-weight: 600 !important;
}

.replace-table tbody tr td a:hoshowintersectver {
  color: #b9ce1e !important;
  text-decoration: underline;
}
</style>
